import React from "react";
import { StyleSheet, Text, View } from "react-native";
import { Calendar, Clock, MapPin, Users } from "lucide-react-native";

import EventSchedule from "./EventSchedule";
import WebsiteButton from "./WebsiteButton";

import Notice from "@/Components/Alerts/Notice";
import { formatDate, formatTime } from "@/formatting/datetime";
import {
  formatLocationAddress,
  formatSecondaryAddress,
} from "@/formatting/location";
import { formatNumberForDisplay } from "@/formatting/number";
import { type EventOverview } from "@/schemas/events/EventOverview";

interface EventDetailsProps {
  details: EventOverview;
}

function EventDetails({ details }: EventDetailsProps): React.JSX.Element {
  return (
    <View style={styles.container}>
      <View style={styles.row}>
        <Users size={25} color="#01579b" />
        <View style={styles.textContainer}>
          <Text style={styles.primaryText}>Expected Attendance</Text>
          <Text style={styles.secondaryText}>
            {formatNumberForDisplay(details.expectedAttendance)}
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <Calendar size={25} color="#01579b" />
        <View style={styles.textContainer}>
          <Text style={styles.primaryText}>
            {formatDate(details.startDateTime, details.timeZone)}
          </Text>
          <Text style={styles.secondaryText}>
            {formatTime(details.startDateTime, details.timeZone)} -{" "}
            {formatTime(details.endDateTime, details.timeZone)}
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <MapPin size={25} color="#01579b" />
        <View style={styles.textContainer}>
          <Text style={styles.primaryText}>
            {formatSecondaryAddress(details.location.address)}
          </Text>
          <Text style={styles.secondaryText}>
            {formatLocationAddress(details.location)}
          </Text>
        </View>
      </View>

      <View style={styles.row}>
        <Clock size={25} color="#01579b" />
        <View style={styles.textContainer}>
          <Text style={styles.primaryText}>Event Schedule</Text>
        </View>
      </View>

      <Notice
        title="Planning in Progress"
        message="Information is being updated as event progresses."
        timestamp={{
          lastUpdate: "Today",
        }}
      />

      <EventSchedule schedule={details.schedule} />
      <View style={styles.buttonContainer}>
        <WebsiteButton link={details.website} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    marginVertical: 24,
  },
  row: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 16,
  },
  textContainer: {
    marginLeft: 12,
  },
  primaryText: {
    fontSize: 16,
    fontWeight: "500",
  },
  secondaryText: {
    fontSize: 14,
    color: "#6B7280", // gray-500
  },
  buttonContainer: {
    marginTop: 16,
    alignItems: "center",
  },
});

export default EventDetails;
